export default __webpack_public_path__ + "static/media/Shadow's Boots of the Smoldering Throne.97db14c6.jpg";